import React from "react";

export const Cloud = () => (
  <svg fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-macaw-ui-candidate>
    <g clipPath="url(#a)">
      <path
        d="M15 8.333h-1.05a6.667 6.667 0 1 0-6.45 8.334H15a4.167 4.167 0 1 0 0-8.334Z"
        stroke="currentColor"
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
